module.exports = __webpack_public_path__ + "img/la-nacion-site.jpg";